import { Space, Typography } from "antd"
import { MasterConfigs } from "../../../interfaces/entity"
import RenderForm from "../../../components/Forms/Form"
import React, { forwardRef, useEffect, useImperativeHandle } from "react"
import { useDispatch } from "react-redux"
import { FormInstance } from "antd/lib"

const { Text } = Typography

interface Props {
    onLoadingChange?: (loading: boolean) => void;
}


const LegalTerms = forwardRef((props: Props, ref) => {
    const { onLoadingChange } = props;

    const [form, setForm] = React.useState<FormInstance>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const submitPromiseRef = React.useRef<{ resolve?: (value: any) => void; reject?: (reason?: any) => void }>({});

    const [vendorId, setVendorId] = React.useState<string>('');
    const dispatch = useDispatch();

    const getQueryStep = () => {
        const params = new URLSearchParams(location.search);
        const _vendorId = params.get('vendor')
        setVendorId(_vendorId || '')
        return _vendorId
    };

    useEffect(() => {
        getQueryStep()
    }, [location.search]);


    useImperativeHandle(ref, () => ({
        submitStep: () => {
            return new Promise((resolve, reject) => {
                submitPromiseRef.current = { resolve, reject };
                form.submit();
            });
        }
    }));

    useEffect(() => {
        onLoadingChange?.(loading);
    }, [loading, onLoadingChange]);


    const config: MasterConfigs = {
        api: () => "/v1/vendor",
        apiParams: {
            termsAndConditions: true,
        },
        afterSubmit: (res: any) => {
            submitPromiseRef.current?.resolve?.(res);
            setLoading(false);
        },
        onError: (error: any) => {
            submitPromiseRef.current?.reject?.(error);
            setLoading(false);
        },
        modalTitle: () => "Vendor Registration sss",
        getFormColumns: () => [
            {
                span: 24,
                type: 'custom',
                formItem: () => <Space direction="vertical" size="small">
                    <Text strong>Legal Terms</Text>
                    <Text>1) Our payment terms are <b>45 days</b> from the date the invoice is raised. <b>No advance payment</b> will be made, and <b>no payment</b> will be released before <b>45 days</b> from the invoice date.</Text>
                    <Text>2) If we find that the provided resources are <b>not genuine</b> at any time, <b>Accelgrowth reserves the right</b> to take appropriate action against both the <b>vendor and the developer</b>.</Text>
                    <Text>3) If the <b>client is not satisfied</b> with the developer's work, an <b>immediate replacement</b> of the developer will be required, subject to the client's approval.</Text>
                    <Text>4) If the <b>client terminates the contract</b> due to any unauthenticated or unsatisfactory reason related to the developer's performance, the <b>vendor will not be entitled to any payment</b> in such a case.</Text>
                    <Text>5) If <b>fraud is detected</b> from the vendor's side at any time, the <b>vendor will be required to return all payments</b> earned for the respective developer.</Text>
                    <Text>6) If <b>fraud is detected</b> for even one developer, <b>Accelgrowth reserves the right to terminate the entire contract</b>, including all other developers provided by the same vendor.</Text>
                </Space>
            },
            {
                span: 24,
                type: 'custom',
                formItem: () => <Space direction="vertical" size="small">
                    <Text type="danger">By clicking Start and Next, you agree to the above terms and conditions.</Text>
                </Space>
            }
        ]
    }

    return <RenderForm config={config} formInstance={(form) => setForm(form)} setLoading={(e) => setLoading(e)} id={vendorId} />

})

export default LegalTerms